import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Privacy() {
  const nav = useNavigate();
  return (
    <div className="app-shell bg-aurora min-h-screen pb-10" data-testid="privacy-page">
      <div className="px-6 pt-10 flex items-center gap-3 mb-4">
        <button onClick={() => nav(-1)} className="w-10 h-10 rounded-full bg-white/80 flex items-center justify-center shadow-sm">
          <ArrowLeft size={18} />
        </button>
        <h1 className="font-display text-3xl text-[#332D38]">Ochrana osobních údajů</h1>
      </div>

      <div className="px-6 space-y-4 text-sm leading-relaxed text-[#332D38]">
        <p className="text-[#8A7E91] text-xs">Verze 1.0 — poslední aktualizace: {new Date().toLocaleDateString("cs-CZ")}</p>

        <section className="glass-card p-5">
          <h2 className="font-display text-lg mb-2">1. Správce údajů</h2>
          <p>Sentra AI (kontakt: <span className="text-[#0F3D34] underline">podpora@sentra.cz</span>) je správcem osobních údajů podle GDPR (Nařízení EU 2016/679).</p>
        </section>

        <section className="glass-card p-5">
          <h2 className="font-display text-lg mb-2">2. Jaká data zpracováváme</h2>
          <ul className="list-disc pl-5 space-y-1">
            <li><strong>Registrace:</strong> e-mail, jméno, věk, pohlaví, preference, souhlas s podmínkami</li>
            <li><strong>Profil:</strong> fotky, bio, odpovědi z dotazníku kompatibility</li>
            <li><strong>Aktivita:</strong> matche, likes, zprávy (jen s tvým souhlasem díky matchi)</li>
            <li><strong>AI analýzy:</strong> texty konverzací, které nahraješ (pouze pro tebe)</li>
            <li><strong>Technická data:</strong> IP adresa, typ zařízení (pro bezpečnost)</li>
            <li><strong>Platby:</strong> Stripe token (číslo karty <strong>neukládáme</strong>)</li>
          </ul>
        </section>

        <section className="glass-card p-5">
          <h2 className="font-display text-lg mb-2">3. Právní základ</h2>
          <ul className="list-disc pl-5 space-y-1">
            <li><strong>Souhlas</strong> — registrace, marketing (můžeš kdykoli odvolat)</li>
            <li><strong>Plnění smlouvy</strong> — poskytování služby seznamky</li>
            <li><strong>Oprávněný zájem</strong> — bezpečnost, prevence zneužití</li>
            <li><strong>Zákonná povinnost</strong> — daňové doklady k platbám</li>
          </ul>
        </section>

        <section className="glass-card p-5">
          <h2 className="font-display text-lg mb-2">4. Komu data předáváme</h2>
          <ul className="list-disc pl-5 space-y-1">
            <li><strong>Anthropic (Claude AI)</strong> — analýzy konverzací (data jsou zpracována anonymizovaně, neukládají se pro trénink)</li>
            <li><strong>Stripe</strong> — zpracování plateb (PCI-DSS certifikovaný)</li>
            <li><strong>Cloud hosting (Emergent/AWS EU)</strong> — provoz aplikace</li>
          </ul>
          <p className="mt-2"><strong>Data nikdy neprodáváme třetím stranám pro marketing.</strong></p>
        </section>

        <section className="glass-card p-5">
          <h2 className="font-display text-lg mb-2">5. Jak dlouho data uchováváme</h2>
          <ul className="list-disc pl-5 space-y-1">
            <li>Aktivní účet — po celou dobu aktivity</li>
            <li>Smazaný účet — <strong>okamžitě smazáno vše kromě anonymizovaných záznamů o platbách</strong> (10 let dle daňového zákona)</li>
            <li>AI analýzy — dokud si je nesmažeš, nebo max. 12 měsíců</li>
          </ul>
        </section>

        <section className="glass-card p-5">
          <h2 className="font-display text-lg mb-2">6. Tvá práva</h2>
          <ul className="list-disc pl-5 space-y-1">
            <li><strong>Právo na přístup</strong> — kdykoli si vyžádáš, co o tobě máme</li>
            <li><strong>Právo na opravu</strong> — v profilu si upravíš cokoli</li>
            <li><strong>Právo na výmaz</strong> — Nastavení → Smazat účet (okamžité smazání)</li>
            <li><strong>Právo na přenositelnost</strong> — na vyžádání pošleme JSON export</li>
            <li><strong>Právo vznést námitku</strong> — proti marketingu, kdykoli</li>
            <li><strong>Stížnost u ÚOOÚ</strong> — Úřad pro ochranu osobních údajů (uoou.cz)</li>
          </ul>
          <p className="mt-2">Pro uplatnění napiš na <span className="text-[#0F3D34] underline">podpora@sentra.cz</span>.</p>
        </section>

        <section className="glass-card p-5">
          <h2 className="font-display text-lg mb-2">7. Bezpečnost</h2>
          <ul className="list-disc pl-5 space-y-1">
            <li>Hesla — bcrypt hash (nikdy je nikdo nevidí, ani my)</li>
            <li>Komunikace — HTTPS/TLS 1.3 šifrování</li>
            <li>Server — v EU, přístup logován</li>
            <li>2FA pro Premium účty (připravujeme)</li>
          </ul>
        </section>

        <section className="glass-card p-5">
          <h2 className="font-display text-lg mb-2">8. Cookies</h2>
          <p>Používáme jen <strong>nezbytné cookies</strong> pro přihlášení (auth token). Žádné sledovací ani reklamní cookies.</p>
        </section>

        <section className="glass-card p-5">
          <h2 className="font-display text-lg mb-2">9. Děti</h2>
          <p>Sentra je pouze pro osoby <strong>18+</strong>. Pokud zjistíme účet nezletilé osoby, okamžitě jej smažeme.</p>
        </section>

        <section className="glass-card p-5">
          <h2 className="font-display text-lg mb-2">10. Kontakt na DPO</h2>
          <p>Pověřenec pro ochranu údajů: <span className="text-[#0F3D34] underline">dpo@sentra.cz</span></p>
        </section>

        <Link to="/terms" className="block text-center py-3 text-[#0F3D34] font-medium underline">Přečti si i Podmínky použití →</Link>
      </div>
    </div>
  );
}
